import PropTypes from 'prop-types'
import clx from 'classnames'
import { Steps as AntdSteps, Button } from 'antd'
import Card from '../../../Common/Card'
import { useStepIndex, useStepActions } from './hooks/useSteps'
import useBrands from './hooks/useBrands'
import ResetStepButton from './ResetStepButton'
import RetryStepButton from './RetryStepButton'
import ProposalChecklistAlert from './StepContent/ProposalChecklistAlert'
import { sendI13nClickEvent } from '../../../../../lib/i13nUtil'
import styles from './index.css'
import { FORM_NAME } from './constants'
import { STEP_CONFIG, STEP_TITLES } from './stepConfig'
import { getI13nModel } from './Clone.ga'

const StepContent = () => {
  const [currentStep] = useStepIndex()
  const { nextStep } = useStepActions()
  useBrands()

  const config = STEP_CONFIG[currentStep]
  if (!config) {
    return null
  }

  const StepComponent = config.component

  if (currentStep === 0) {
    return <StepComponent nextStep={nextStep} />
  }
  return <StepComponent />
}

const Steps = ({ i13n }) => {
  const [currentStep] = useStepIndex()

  const handleSubmitClick = () => {
    sendI13nClickEvent({ i13n, i13nModel: getI13nModel() })
  }

  return (
    <Card
      hasPadding
      hasShadow
      className={styles.stepContent}
    >
      <div className={styles.stepsContainer}>
        <AntdSteps
          current={currentStep}
          items={STEP_TITLES.map((title) => ({ title }))}
        />
      </div>
      <StepContent />
      <div className={styles.stepActions}>
        <Button
          type='primary'
          size='large'
          htmlType='submit'
          form={FORM_NAME}
          className={clx({ hidden: currentStep > 0 })}
          onClick={handleSubmitClick}
        >
          開始複製
        </Button>
        <ResetStepButton />
        <RetryStepButton />
      </div>
      {currentStep > 0 && (
        <div className={styles.proposalChecklistAlertWrapper}>
          <ProposalChecklistAlert />
        </div>
      )}
      <div
        className={clx(styles.tipsText, {
          hidden: currentStep > 0
        })}
      >
        點擊「開始複製」，即表示您確認擁有該商品圖片/文案使用權，並同意遵守平台內容規範
      </div>
    </Card>
  )
}

Steps.propTypes = {
  i13n: PropTypes.object
}

export default Steps
